export default {
  SET_FEATURES (state, features) {
    state.features = features
  },
  TOGGLE_MODE (state) {
    state.mode = state.mode === 'search'
      ? 'dialpad'
      : 'search'
  },
  SET_MODE (state, value) {
    state.mode = value
  },
  SET_KEYWORD (state, keyword) {
    state.keyword = keyword
  },
  SET_NUMBER (state, number) {
    state.number = number
  },
  SET_IS_SEARCHING (state, value) {
    state.isSearching = value
  },
  SET_SEARCH_RESULTS (state, value) {
    state.searchResults = value
  },
  SET_HAS_SEARCHED (state, value) {
    state.hasSearched = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dialer/mutations.js